import React from 'react'

import CaluRawAutoComplete from '../CaluRawAutoComplete'

export const CaluAutoComplete = (props) => {
  return <CaluRawAutoComplete {...props} error={Boolean(props.error)} />
}
